// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:54:20

export default {
  "id": "traffic-parking",
  "slug": "traffic-parking",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ba9a83655324409395fa053145efa591-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ba9a83655324409395fa053145efa591/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Traffic Parking",
      "description": "Traffic Parking is a car puzzle game to park the car into the garage of the house, the car is on the road looking for a way to go home by avoiding other cars. Sometimes there are rocks on the road that must be removed so that the car can pass through. You also need tricks at certain levels to make the road passable for cars.",
      "instructions": "Touch the car to see the car’s path, touch again to drive the car.",
      "genres": [
        "Puzzle",
        "Racing & Driving"
      ],
      "tags": [
        "car",
        "city",
        "crash",
        "traffic"
      ]
    },
    "zh-CN": {
      "title": "交通停车",
      "description": "交通停车是一款汽车益智游戏，目的是将汽车停进房子的车库中。汽车在道路上寻找回家的路，需要避开其他车辆。有时道路上会有石头需要移除，以便汽车通过。在某些关卡中，你还需要使用技巧使道路对汽车通行变得可行。",
      "instructions": "触摸汽车以查看汽车路径，再次触摸以驾驶汽车。",
      "genres": [
        "拼图",
        "竞速与驾驶"
      ],
      "tags": [
        "汽车",
        "城市",
        "碰撞",
        "交通"
      ]
    },
    "zh-TW": {
      "title": "交通停車",
      "description": "交通停車是一款汽車拼圖遊戲，遊戲目標是將車子停進房屋的車庫中。車子正在道路上尋找回家的路，並且要避開其他車輛。有時候道路上會有石頭需要移除，以便車子能夠通過。你還需要在某些關卡中使用技巧來使道路對車輛通行。",
      "instructions": "觸碰車輛以查看車輛路徑，再觸碰一次以開車。",
      "genres": [
        "謎題",
        "賽車與駕駛"
      ],
      "tags": [
        "車",
        "城市",
        "撞車",
        "交通"
      ]
    },
    "zh-HK": {
      "title": "交通停車",
      "description": "交通停車是一款汽車拼圖遊戲，遊戲目標是將車停進房屋的車庫。車在馬路上尋找回家的路，同時要避開其他車輛。有時候馬路上會有石頭，必須移除才能讓車通行。在特定關卡中，你還需要使用技巧使道路對車輛可通行。",
      "instructions": "觸碰車輛以查看車輛路徑，再觸碰一次以駕駛車輛。",
      "genres": [
        "謎題",
        "賽車及駕駛"
      ],
      "tags": [
        "車",
        "城市",
        "撞車",
        "交通"
      ]
    },
    "ja": {
      "title": "交通駐車",
      "description": "トラフィック・パーキングは、車を家のガレージに駐車させるパズルゲームです。車は道路を進み、他の車を避けながら帰宅する方法を見つけ出しています。時には道に岩がありますが、それを取り除く必要があります。また、あるレベルでは、車が通れるようにするために特技が必要です。",
      "instructions": "車をタッチして車の経路を確認し、もう一度タッチして車を運転します。",
      "genres": [
        "パズル",
        "レース&ドライビング"
      ],
      "tags": [
        "車",
        "街",
        "クラッシュ",
        "交通"
      ]
    },
    "ko": {
      "title": "트래픽 파킹",
      "description": "Traffic Parking은 집의 주차장에 차를 주차시키는 자동차 패uzzle 게임입니다. 차는 도로 위에 있으며 다른 차를 피하며 집으로 돌아가는 방법을 찾고 있습니다. 때로는 차가 통과할 수 있도록 돌을 제거해야 할 때가 있습니다. 또한 일부 레벨에서는 차가 도로를 통과할 수 있도록 해야 할 트릭이 있습니다.",
      "instructions": "차를 눌러 차의 경로를 확인하세요, 다시 눌러 차를 운전하세요.",
      "genres": [
        "퍼즐",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "자동차",
        "도시",
        "충돌",
        "교통"
      ]
    },
    "fr": {
      "title": "Stationnement Routier",
      "description": "Traffic Parking est un jeu-puzzle de voiture pour garer la voiture dans le garage de la maison. La voiture se trouve sur la route et cherche un chemin pour rentrer chez elle tout en évitant les autres voitures. Parfois, il y a des rochers sur la route qui doivent être enlevés afin que la voiture puisse passer. Vous devez également utiliser des astuces à certains niveaux pour rendre la route passable pour les voitures.",
      "instructions": "Touchez la voiture pour voir son itinéraire, touchez à nouveau pour conduire la voiture.",
      "genres": [
        "Puzzle",
        "Course & Conduite"
      ],
      "tags": [
        "car = voiture\ncity = ville\ncrash = accident\ntraffic = circulation"
      ]
    }
  }
};
